import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './DefaultAddress.scss';

interface DefaultAddressProps {
  address: string;
  onEdit?: () => void;
  isReadonly?: boolean;
}

const DefaultAddress: React.FC<DefaultAddressProps> = ({
  address,
  onEdit,
  isReadonly = false
}) => {
  const { t } = useTranslation('new_order');

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEdit?.();
  };


  if (isReadonly) {
    return (
      <div className="default-address readonly">
        <div className="address-content-readonly">
          <div className="address-text">
            <div className="address-line">{address}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="default-address">
      <div className="address-content">
        <div className="address-text">
          <div className="address-line">{address}</div>
        </div>
        <Button
          type="link"
          className="edit-button"
          onClick={handleEditClick}
        >
          {t('edit')}
        </Button>
      </div>

    </div>
  );
};

export default DefaultAddress;